(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.superfood-tabs').forEach(function (section) {
      const tabs = section.querySelectorAll('.superfood-tabs__tab');
      const panels = section.querySelectorAll('.superfood-tabs__panel');
      if (!tabs.length || !panels.length) return;

      // Ensure one is active on load
      let activeTab = section.querySelector('.superfood-tabs__tab.active') || tabs[0];
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      activeTab.classList.add('active');
      const key = activeTab.getAttribute('data-tab');
      const firstPanel = section.querySelector(`.superfood-tabs__panel[data-panel="${key}"]`);
      if (firstPanel) firstPanel.classList.add('active');

      // Click handler
      tabs.forEach(function (tab) {
        tab.onclick = function (e) {
          e.preventDefault();
          if (tab.classList.contains('active')) return;
          tabs.forEach(t => t.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));
          tab.classList.add('active');
          const idx = tab.getAttribute('data-tab');
          const target = section.querySelector(`.superfood-tabs__panel[data-panel="${idx}"]`);
          if (target) target.classList.add('active');
          if (window.innerWidth <= 768) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
